import React from "react";
import { useQuery } from "@apollo/client";
import { useParams, Link } from "react-router-dom";

import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { QUERY_LOG } from "../../../config/graphql/query";

import {
  formatJson,
  methodAndEndpoint,
  LogBlocks,
  LogField,
  LogFields,
} from "../../../components/LogDetail";

const Log = React.memo(() => {
  const { id, type } = useParams<{ id: string; type: LevelInfoType }>();

  const { t } = useTranslation(["logs", "common"]);

  const { data } = useQuery<{ log?: ILog }>(QUERY_LOG, {
    skip: !id,
    variables: { id, type },
  });

  const log = data?.log;

  return (
    <div className="container-fluid">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb my-3">
          <li className="breadcrumb-item">
            <Link to="/logs">{t("logs:log.nav.log", { count: 2 })}</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {t("logs:log.nav.log", { count: 1 })}
          </li>
        </ol>
      </nav>
      <LogFields>
        <LogField label={t("logs:log.card.created")}>
          {log &&
            dayjs(log.createdAt).local().format("DD-MM-YYYY HH:mm:ss.SSS")}
        </LogField>
        <LogField label={t("logs:log.card.message")}>{log?.message}</LogField>
        <LogField label={t("logs:log.card.endpoint")}>
          {methodAndEndpoint(log?.method, log?.endpoint)}
        </LogField>
        {log?.status !== undefined && log?.status !== null && (
          <LogField label={t("logs:log.card.status")}>{log.status}</LogField>
        )}
        {!!log?.responseDuration && (
          <LogField label={t("logs:log.card.duration")}>
            {log.responseDuration} ms
          </LogField>
        )}
        <LogField label={t("logs:log.card.ip")}>{log?.ip}</LogField>
      </LogFields>
      <LogBlocks
        blocks={[
          {
            key: "payload",
            title: t("logs:log.card.payload"),
            text: formatJson(log?.payload),
          },
        ]}
      />
    </div>
  );
});

export default Log;
